import RxOp from 'rxjs-operators';
import userService from '../../../services/userService';
import { sendHelpRequest } from '../../../services/userService/types';
import { HelpData } from './types';

export const SUBJECT_OPTIONS = {
  1: 'Problema com a Compra',
  2: 'Tenho dúvidas sobre o Evento',
  3: 'Críticas ou Sugestões',
  4: 'Outros',
};

export const sendHelpData = (helpData: HelpData, eventId: string) => {
  const subject = {
    title: SUBJECT_OPTIONS[helpData.subject],
    option: helpData.subject > 1 ? 'producer' : 'eduzz',
  };

  const helpDataRequest: sendHelpRequest = {
    client_contact: helpData.client_contact,
    client_name: helpData.client_name,
    client_phone: helpData.client_phone,
    eventId,
    message: helpData.message,
    subject: subject.title,
    subject_opt: subject.option,
  };

  return userService.sendHelp(helpDataRequest).pipe(RxOp.map(response => response));
};
